// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>

import * as Sentry from '@sentry/vue';

if (import.meta.env.PROD){
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        tracesSampleRate: 0.0
    })
}

import jstz from "jstz"
window.jstz = jstz;

// Resend confirmation form handler
import '../src/resend_confirmation.js';

// let cls = 0;

// new PerformanceObserver((entryList) => {
//   for (const entry of entryList.getEntries()) {
//     if (!entry.hadRecentInput) {
//       cls += entry.value;
//       console.log('Current CLS value:', cls, entry);
//     }
//   }
// }).observe({type: 'layout-shift', buffered: true});
